import axios from 'axios'

import qs from 'qs'
// axios 配置
axios.defaults.timeout = 30000;   //设置超时时间，例如超过10s,就会告知用户当前请求超时，请刷新等等。

//let AUTH_TOKEN = localStorage.getItem("token")

//console.log('token----',AUTH_TOKEN)
//请求带token
// AUTH_TOKEN=(function(){
//   return localStorage.getItem("token");
//   console.log('token----',token)
// })();
//console.log('外面的token',AUTH_TOKEN)

// if(AUTH_TOKEN){
//   axios.defaults.headers.common["Authorization"] = 'Bearer ' + AUTH_TOKEN;
//   //console.log('我有token',AUTH_TOKEN)
// }
//axios.defaults.headers.common["PLATFORM"] = "H5";
axios.defaults.headers.post['Content-Type'] = 'application/json' // post请求的时候，我们需要加上一个请求头，所以可以在这里进行一个默认的设置，即设置post的请求头为application/x-www-form-urlencoded;charset=UTF-8
if (process.env.NODE_ENV == 'development') { //开发环境
  // axios.defaults.baseURL = 'http://121.41.29.241:9090';
  axios.defaults.baseURL = 'https://api.pkzoo.com';
  //console.log('目前的开发环境')
} else if (process.env.NODE_ENV == 'debug') { //测试环境
  axios.defaults.baseURL = 'https://api.pkzoo.com';
} else if (process.env.NODE_ENV == 'production') { //正式环境
  axios.defaults.baseURL = 'https://api.pkzoo.com';
}

let that = this;
// POST传参序列化【添加请求拦截器】
axios.interceptors.request.use((config) => {
  // 在发送请求之前做些什么
  // if (config.method === 'post') {
  //   config.data = qs.stringify(config.data)
  // }
  return config
}, (error) => {
  // 对请求错误做些什么
  return Promise.reject(error)
})
// 返回状态判断【添加响应拦截器】

axios.interceptors.response.use((res) => {
  // 对响应数据做点什么
  if (res.status === 200) {
    return res
  } else {
    return Promise.reject(res)
  }
}, (err) => {
  console.log('22', err.response)
  //对响应错误做点什么
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)';
        break;
      case 401:
        err.message = '登录，请重新登录(401)';
        //console.log('登录，请重新登录(401)');
       
        break;       
      case 403:
        err.message = '拒绝访问(403)';
        break;
      case 404:
        err.message = '请求出错(404)';
      
        console.log('请求出错(404)啦啦啦8888888888888啦啦')
        break;
      case 408:
        err.message = '请求超时(408)';
        break;
      case 500:
        err.message = '服务器错误(500)';
        break;
      case 501:
        err.message = '服务未实现(501)';
        break;
      case 502:
        err.message = '网络错误(502)';
        break;
      case 503:
        err.message = '服务不可用(503)';
        break;
      case 504:
        err.message = '网络超时(504)';
        break;
      case 505:
        err.message = 'HTTP版本不受支持(505)';
        break;
      default:
        err.message = `连接出错(${err.response.status})!`;
    }
  } else {
    err.message = '连接服务器失败!'
  }
  //message.error(err.response.status);

  return Promise.reject(err.response.status);

})

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export function Delete(url,id) {
  console.log('url',id)
  return new Promise((resolve, reject) => {
    axios.delete(url+id)
      .then(res => {
        console.log('url',url)
        resolve(res.data)
      })
      .catch((error) => {
        console.log('url',url)
        reject(error)
      })
  })
}


export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    })
  });
}
// export default {
//   /**
//    * 获取广告信息
//    */
//   getAds(params) {
//     return post('/api/ad/queryADs', params)
//   },
//   getAreas(params) {
//     return post('/api/area/getAll', params)
//   }
// }



// WEBPACK FOOTER //
// ./src/api/axios.js